/* prettier-ignore */

import { Component, ElementRef, HostListener, inject, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { debounceTime, distinctUntilChanged, Subject, tap } from 'rxjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NewCustomRouteService } from '../../new-custom-route.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { NewDetailsPage } from 'src/app/pages/new-details/new-details.page';

@Component({
  selector: 'add-item',
  imports: [
    CommonModule, 
    TranslateModule, 
    ReactiveFormsModule, 
    FormsModule,
    SharedModule,
    IonicModule
  ],
  standalone: true,
  templateUrl: './add-item.component.html',
  styleUrls: ['./add-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AddItemComponent {
    @ViewChild("inputSearch") inputSearch!: ElementRef;
    @Input("availableTechItems") availableTechItems: any;
    @Input("availableItems") availableItems: any;
    @Input("day") day: any;
    @Input("hour") hour: any;
    public searchItems: any = [];
    private searchInputSubject: Subject<string> = new Subject<string>();
    public searchInputValue: any;
    private modalController = inject(ModalController);
    public translate = inject(TranslateService);
    private routeService = inject(NewCustomRouteService)
    public categories: any = [];
    public selectedCategory: any = null;
    public selectedApp: any = null;
    private modal: any;
    public apps: any;

    constructor() {
      this.searchInputSubject.pipe(debounceTime(300), distinctUntilChanged()).subscribe((searchText) => {
        this.onSearch(searchText); 
      });
    }

    ngOnInit(){
      this.searchItems = structuredClone(this.availableItems);
      this.categories = this.routeService.getCategories()?.filter(category => !category.sections_app || category.sections_app?.includes('register'));
      this.apps = this.routeService.getApps()?.map(app => ({id: app.client_id, name: app.name}));
    }

    async showItemInfo(item){
      this.modal = await this.modalController.create({
        component: NewDetailsPage,
        cssClass: "detailsModal",
        componentProps: {
          isModal: true,
          item: item,
          addItem: true,
        },
      });
      await this.modal.present();
      const { data } = await this.modal.onDidDismiss();
      if (!data) 
        return;

      this.modalController.dismiss(item);
    }
  
    addItem(event, item){
      event.stopPropagation();
      this.modalController.dismiss(item);
    }

    handleSelectChange(){
      if (this.selectedCategory && this.selectedCategory !== "null"){
        if (this.selectedCategory.trim() === 'tech'){
          this.searchItems = this.availableTechItems;
        }
        else{
          this.searchItems = this.availableItems.filter((item) =>  item.categories?.includes(this.selectedCategory) );
        }
      }else{
        this.searchItems = this.availableItems;
      }

      if (this.selectedApp && this.selectedApp !== 'null'){
        this.searchItems = this.searchItems?.filter(item => item.client_id?.includes(`${this.selectedApp}`))
      }

      if(this.searchInputValue && this.searchInputValue !== ""){
        this.searchItems = this.searchItems.filter((item) => 
          this.normalizeString(item.name?.[this.translate.currentLang]?.toLowerCase()).includes(this.normalizeString(this.searchInputValue.toLocaleLowerCase())) 
        );
      }
    }

    onSearch(searchText: string) {
      if (this.selectedCategory?.trim() === 'tech'){
        this.searchItems = this.availableTechItems.filter((item) => 
          this.normalizeString(item.name?.[this.translate.currentLang]?.toLowerCase()).includes(this.normalizeString(searchText.toLocaleLowerCase()))
        );
      }
      if (this.selectedCategory && this.selectedCategory !== 'null'){
        this.searchItems = this.availableItems.filter((item) => 
          this.normalizeString(item.name?.[this.translate.currentLang]?.toLowerCase()).includes(this.normalizeString(searchText.toLocaleLowerCase())) && item.categories?.includes(this.selectedCategory)
        );
      }
      if (!this.selectedCategory || this.selectedCategory === 'null'){
        this.searchItems = this.availableItems.filter((item) => 
          this.normalizeString(item.name?.[this.translate.currentLang]?.toLowerCase()).includes(this.normalizeString(searchText.toLocaleLowerCase())) 
        );
      }

      if (this.selectedApp && this.selectedApp !== 'null'){
        this.searchItems = this.searchItems?.filter(item => item.client_id?.includes(`${this.selectedApp}`))
      }

    }

    onInputChange(value: string) {
      this.searchInputSubject.next(value);
    }

    normalizeString(str: string): string {
      return str?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, "") || "";
    }

    closeModal(){
      this.modalController.dismiss();
    }

    checkCustomStyle(){
      const screenWidth = window.innerWidth;
      const itemsLength = this.searchItems?.length ?? 0;
      if ((screenWidth / itemsLength) > 250)
        return true
      
      return false;
    }
}